// @flow
import * as Immutable from "immutable";

import { csrfFetch } from "./fetch.js";

import type {
  GazelleData,
  GazelleObject,
  GazelleRef
} from "../types/gazelle.js";

export function findRef(
  gazelleData: GazelleData,
  ref: GazelleRef
): ?GazelleObject {
  const gazelleObject = gazelleData.find(
    obj => obj.get("id") == ref.get("id") && obj.get("type") == ref.get("type")
  );
  if (gazelleObject == null) {
    console.error("Could not find gazelle object", ref.toJS());
  }
  return gazelleObject;
}

export async function fetchGazellePreviewData(body: {
  type: string,
  ap_object_id?: number,
  data: any
}): Promise<GazelleData> {
  const resp = await csrfFetch(
    "/app-server-api/ajax/html-to-vertical-stack-json/",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json; charset=utf-8"
      },
      body: JSON.stringify(body)
    }
  );
  const jsonData = await resp.json();
  return Immutable.fromJS(jsonData);
}



// WEBPACK FOOTER //
// ./enso_cms/static/enso-cms/js/utils/gazelle.js